import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { KnowYourDeveloperComponent } from './know-your-developer.component';

const appRoutes: Routes = [
  {
    path: '',
    component: KnowYourDeveloperComponent,
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: ''
  }
];

export const KydRoutingProviders: any[] = [];

export const KydRouting: ModuleWithProviders<any> =
  RouterModule.forChild(appRoutes);
